// extracted by mini-css-extract-plugin
export var color = "style-mod--color--4ea71";
export var colorSwatch = "style-mod--color-swatch--c454c";
export var selected = "style-mod--selected--0d440";
export var swatchLabel = "style-mod--swatch-label--d340a";
export var swatchList = "style-mod--swatch-list--52a63";
export var swatchTitle = "style-mod--swatch-title--23136";